import { render, staticRenderFns } from "./DynamicFiltersSave.vue?vue&type=template&id=ca6b24f2&scoped=true"
import script from "./DynamicFiltersSave.vue?vue&type=script&lang=js"
export * from "./DynamicFiltersSave.vue?vue&type=script&lang=js"
import style0 from "./DynamicFiltersSave.vue?vue&type=style&index=0&id=ca6b24f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6b24f2",
  null
  
)

export default component.exports